// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3lbpb{height:58px;height:5.8rem}._3lbpb,.ZTdp_{width:48px;width:4.8rem}.ZTdp_{height:32px;height:3.2rem}.q4DX9{border:.1rem solid #e0e8f2;border-radius:.4rem}._1kMno{fill:#f5f9ff;font-size:12px;font-size:1.2rem;font-weight:500;line-height:16px;line-height:1.6rem;text-anchor:middle}", ""]);
// Exports
exports.locals = {
	"meal": "_3lbpb",
	"meal__icon": "ZTdp_",
	"meal__image": "q4DX9",
	"meal__text": "_1kMno"
};
module.exports = exports;
